import React from 'react'

function AppSetting() {
  return (
    <div>AppSetting</div>
  )
}

export default AppSetting